import { getLogger } from '@omnia/ui/src/lib/services/logger/logger.service'
import { gtm } from '@/common/services/gtm/gtm.service'
import { UserPropertiesUpdateDataLayer } from '@/common/services/models-gtm'
import { getMembershipTier } from '@/common/utils/getMembershipTier'

export const sendUserProperties = async () => {
    const logger = getLogger('user-properties.gtm').value
    try {
        const membershipTier = await getMembershipTier()
        if (!membershipTier) return
        const dataLayer = new UserPropertiesUpdateDataLayer(membershipTier)
        gtm.sendDataLayer(dataLayer)
    } catch (e) {
        logger.error('Error sending user properties update data layer:', e)
    }
}
